const mapURLs = new Set()

export const urlChecked = (url) => (
  mapURLs.has(url)
)

export const checkURL = async (vm, url) => {
  if (!url) return
  if (!vm.isMounted) return
  if (!vm.isLoading) return

  if (mapURLs.has(url)) {
    vm.isLoading = false
    return
  }

  const isOK = await hasURL(url)
  if (!vm.isMounted) return

  if (isOK) {
    mapURLs.add(url)
    vm.isLoading = false
    return
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      checkURL(vm, url).then(resolve)
    }, 1000)
  })
}

const hasURL = (url) => (
  new Promise((resolve) => {
    try {
      const http = new XMLHttpRequest()
      const isS3Url = url.includes('amazonaws.com') || url.includes('X-Amz-Signature')

      const method = isS3Url ? 'GET' : 'HEAD'

      http.open(method, url, true)

      http.onreadystatechange = function () {
        if (this.readyState === this.DONE) {
          const hasError = this.status >= 400
          resolve(!hasError)
        }
      }

      http.send()
    } catch {
      resolve(false)
    }
  })
)
